module.exports = __webpack_public_path__ + "static/media/icon-customers.caf0e9fc.svg";